import { KitchenPriceGroup } from "@prmf/site-data";
import { clsx } from "clsx";

type Props = {
  group: KitchenPriceGroup;
  color?: string;
  className?: string;
};

export default function PriceGroupMeter(props: Props) {
  const data: Record<KitchenPriceGroup, number> = {
    D: 1,
    F: 2,
    H: 2,
    J: 3,
    I: 3,
    HJ: 3,
    M: 4,
  };
  const level = data[props.group];
  return (
    <div className={clsx("flex gap-1", props.className)}>
      {Array.from({ length: 4 }).map((_, i) => (
        <div
          key={i}
          className={clsx(
            "flex h-5 w-5 items-center justify-center bg-neutral-500 p-2",
            "text-xs font-bold text-white",
            i >= level && "opacity-30",
          )}
          style={{ backgroundColor: props.color }}
        >
          &pound;
        </div>
      ))}
    </div>
  );
}
